import React from 'react'

export const DateFormatter = ({ date }: { date: string }): string => {
    //@FixMe sacar argentina y armar dinamico con la zona horaria del phono
    const formattedDate = new Date(date).toLocaleDateString('es-AR')
    return formattedDate
}
